import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box, AccordionSummary, AccordionDetails, Checkbox, FormControlLabel, Accordion,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const STATES = {
  AL: 'Alabama',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CO: 'Colorado',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  ID: 'Idaho',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  PA: 'Pennsylvania',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  VI: 'Virgin Islands',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

const CompactStates = ({ compactStates, setCompactStates }) => {
  const [isAllStatesSelected, setIsAllStatesSelected] = useState(false);

  const handleCheckboxClick = event => {
    const { value } = event.target;
    if (compactStates.includes(value)) {
      setCompactStates(compactStates.filter(el => el !== value));
    } else {
      setCompactStates([...compactStates, value]);
    }
  };

  const selectDeselectAllStates = () => {
    setCompactStates(isAllStatesSelected ? [] : [...Object.keys(STATES)]);
  };

  useEffect(() => {
    setIsAllStatesSelected(Object.keys(STATES).length === compactStates.length);
  }, [compactStates]);

  return (
    <Box mt={1} ml={-3}>
      <Accordion elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-label="Expand"
          aria-controls="additional-actions3-content"
          id="additional-actions3-header"
        >
          <FormControlLabel
            aria-label="Acknowledge"
            onClick={event => event.stopPropagation()}
            onFocus={event => event.stopPropagation()}
            control={(
              <Checkbox
                checked={compactStates.length > 0}
                indeterminate={!isAllStatesSelected}
                onClick={selectDeselectAllStates}
              />
            )}
            label="Compact States"
          />
        </AccordionSummary>
        <AccordionDetails>
          {Object.keys(STATES).map(el => (
            <FormControlLabel
              key={el}
              control={(
                <Checkbox
                  checked={compactStates.includes(el)}
                  name="checkedB"
                  onClick={handleCheckboxClick}
                  value={el}
                  color="primary"
                />
              )}
              label={STATES[el]}
            />
          ))}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

CompactStates.defaultProps = {
  compactStates: [],
};

CompactStates.propTypes = {
  compactStates: PropTypes.arrayOf(PropTypes.string),
  setCompactStates: PropTypes.func.isRequired,
};

export default CompactStates;
